import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useConversationRefresh } from './useConversationRefresh';
import apiService from '../services/apiService';

export const useConversations = (limit = 15) => {
  const { user } = useAuth();
  const { refreshKey } = useConversationRefresh(); // ← ADD THIS
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    if (!user) return;

    const fetchConversations = async () => {
      try {
        setLoading(true);
        
        const url = '/api/v1/conversations';
        const data = await apiService.get(url, user);
        
        let conversationsArray = [];
        
        if (data && data.success && data.data && Array.isArray(data.data.conversations)) {
          conversationsArray = data.data.conversations;
        } else {
          console.warn('Unexpected conversations response structure:', data);
          conversationsArray = [];
        }
        
        // Sort by most recent first
        const sorted = conversationsArray.sort((a, b) =>
          new Date(b.lastActivity || b.createdAt || 0) - new Date(a.lastActivity || a.createdAt || 0)
        );
        
        // Take only the limit for nav display
        const limited = sorted.slice(0, limit);
        
        setConversations(limited);
        setHasMore(sorted.length > limit);
        setError(null);
      } catch (err) {
        console.error('Error fetching conversations:', err);
        setError(err.message);
        setConversations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
    
  }, [user, limit, refreshKey]); // ← ADD refreshKey HERE

  return { conversations, loading, error, hasMore };
};